//use own button soon
import {Button} from '@mui/material'
import styled from 'styled-components'

export const CreateModeButton = styled(Button)`
  width: 150px;
  height: 40px;
  border-radius: 4px;
  padding: 8px 24px;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 600;
  text-transform: none;

  @media (max-width: 960px) {
    width: 100%;
    max-width: 300px;
  }
`

export const CreateModeCancelButton = styled(CreateModeButton)`
  border: 1px solid #e0e0e0;
  color: #424242;
  background: white;

  &:hover {
    background: #f8f9fa;
  }
`

export const CreateModeSaveButton = styled(CreateModeButton)`
  background: #03a9fc;
  color: white;
  border: none;

  &:hover {
    background: #0299e8;
  }

  &:disabled {
    background: #ccc;
    color: #666;
  }
`

export const CreateModeButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding: 24px 44px;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: center;
    padding: 24px 20px;
  }
`

export const EditButton = styled(Button)`
  color: var(--js-blue);
  text-transform: none;
  font-weight: 600;
  padding: 0px !important;
  border-radius: 8px;
  min-width: auto;
  &:hover {
    background: rgba(0, 123, 255, 0.1);
  }
`
